import { render } from "./Indecision.vue?vue&type=template&id=0d0941e4&scoped=true"
import script from "./Indecision.vue?vue&type=script&lang=js"
export * from "./Indecision.vue?vue&type=script&lang=js"

import "./Indecision.vue?vue&type=style&index=0&id=0d0941e4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0941e4"]])

export default __exports__